import React from "react";
import { Grid } from "@mui/material";
import UserDetails from "../../UserDetails/UserDetails";
import { IHeaderTemplateBaseProp } from "../../../Model/UI";
import { Chip } from "../../Chip/Chip";

import "./Header3.scss";
import Utility from "../../../common/utilities";

export interface IHeader3Prop extends IHeaderTemplateBaseProp {
  label1: string;
  label2: string;
  label3: string;
  chip1: string;
}

/*
UI placement:

    label1          label2
    label3
    userDetails             chip
                    
*/

export function Header3(props: IHeader3Prop)  {
  function getHeaderUI()  {
    return (
      <div
        data-testid="header-3"
        className={Utility.getClassNamesFromProps("header-3", props.className)}
      >
        {/* 1st row */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="row-1"
        >
          <div className="dot"> </div>
          <p className="label-1">{props.label1}</p>
          <div className="spacer"></div>
          <p className="label-2">{props.label2}</p>
        </Grid>

        {/* 2nd row */}
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className="row-2"
        >
          <p className="label-3">{props.label3}</p>
        </Grid>

        {/* 3rd row */}
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className="row-3"
        >
          <UserDetails
            userId={props.userDetails.userId}
            userCardName={props.userDetails.userCardName}
            userOrganization={props.userDetails.userOrganization}
          ></UserDetails>
          <div className="spacer"></div>
          <Chip className="chip-1" label={props.chip1}></Chip>
        </Grid>
      </div>
    );
  }

  return getHeaderUI();
}
